var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('app-tabela',{attrs:{"itens":_vm.contrato.documentosContrato,"campos":_vm.campos,"itensPorPagina":_vm.itensPorPagina,"bordered":false,"small":false},scopedSlots:_vm._u([{key:"acoes",fn:function(data){return [_c('btn-download-documento',{attrs:{"documento":data,"dataServicos":_vm.dataServicos}})]}}])})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }